import { IVisitorNavItem } from "../../../../../../../../Interfaces/componentTypes";
import useLanguagesHooks from "../../../../../../../../Components/Languages/setLanguage-hooks";
import { IHeaderMenuDrawerProps } from "./headerMenuDrawer";
import { VisitorPageContents } from "../../../../../visitorPage";

const useHeaderMenuDrawer = (props: IHeaderMenuDrawerProps) => {
    const { is_user, setContentType } = props;
    const { t } = useLanguagesHooks();
    const onHandleNav = (type: VisitorPageContents) => {
        const currentUrl = window.location.href.split('?')[0];
        window.history.pushState({}, '', `${currentUrl}?tab=${type}`);
        setContentType(type)
    };

    const headerMenuDrawerItems: IVisitorNavItem[] = [
        {
            id: VisitorPageContents.PROFILE,
            title: t('My_Business.Home'),
            onClick: () => onHandleNav(VisitorPageContents.PROFILE)
        },
        {
            id: VisitorPageContents.MENU,
            title: t('My_Business.Menu'),
            onClick: () => onHandleNav(VisitorPageContents.MENU)
        },
    ];

    if (is_user) {
        headerMenuDrawerItems.splice(1, 0, {
            id: VisitorPageContents.MY_ORDERS,
            title: t('Visitor.My_Orders'),
            onClick: () => onHandleNav(VisitorPageContents.MY_ORDERS),
        });
    };

   

    return {
        headerMenuDrawerItems
    }
};

export default useHeaderMenuDrawer